// ##### Komarov 2025-07-22
import React, { useState } from 'react';
// ##### 25-05-10 Komarov
import { useHistory } from 'react-router-dom';
// ##### 23-11-09 Komarov
import { useSelector } from 'react-redux';
// ##### 24-04-23 Komarov
// ##### 23-11-22 Komarov
import { Media } from '../../../../helpers/MediaConfig';
// ##### 25-05-10 Komarov
import { makeParamsString } from '../../Helpers/helper';
// ##### 24-12-27 Komarov
import { encryptString } from '../../../../helpers/crypto';
// ##### 25-05-21 Komarov
import BookButtonHotelButton from './BookButtonHotelButton';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../helpers/useValidateQuery';

// ##### 23-09-14 Komarov
// import './BookButtonHotelCSS.css'

// ##### Komarov 2025-07-14
const BookButtonHotel = props => {
  // ##### 25-05-09 Komarov: это Компонент Кнопка и в нём (в его props) хранятся его параметры для данной записи в таблице с тарифами на странице с тарифами отеля (3-й этап поиска)
  const {
    selectedAvailability,
    room_id,
    totalsum,
    tariff_id,
    max_adults,
    pickedCurrency,
    // ##### 25-02-18 Komarov
    nrf,
    start,
    end,
    available_now,
    // ##### 25-05-09 Komarov
    pax,
    // ##### 24-04-17 Komarov
    room_name,
    tariff_type_name,
    cityName,
  } = props;
  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);

  const [booking, setBooking] = useState([]);
  const history = useHistory();

  const redux_search_data = useSelector(
    state => state.hotelsearchdata.hotel_search_data
  );
  // ##### 25-04-21 Komarov
  const localized_city_name = cityName || 'Not set';
  // ##### Komarov 2025-08-02
  const shouldCypherUrlParams = useSelector(
    state => state.siteCypherCodeData.isDataEncrypted
  );
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();

  // ##### 24-03-01 Komarov
  const whitelabel = useSelector(state => state.whitelabel);
  const isWhiteLabelSet = whitelabel.set;
  const company_cipher = whitelabel.company_cipher;
  const promoCode = useSelector(state => state.promocode.promocode);
  // ##### 2025-09-11 Komarov
  const hotelcontent = useSelector(state => state.hotelcontent.hotelcontent);
  // ##### 25-05-15 Komarov: id валюты контракта текущего отеля
  const hotelCurrencyId = useSelector(
    state =>
      state.hotels.hotels_avail.data.hotels[redux_search_data.id]
        ?.contr_currency_id
  );

  // ##### 24-04-17 Komarov
  const AddToBasket = () => {
    const newBooking = {
      tariff_id,
      room_id,
      amount: totalsum || 'No price was shown',
      pickedCurrency,
      rooms: selectedAvailability || 'No availability was shown',
    };
    setBooking([newBooking]);

    const params_string = makeParamsString({
      selected_currency: pickedCurrency,
      service_type_id: 1,
      start,
      end,
      // ##### 25-05-09 Komarov
      pax,
      tariff_id,
      room_id,
      numberofunits: selectedAvailability,
      // ##### Komarov 2025-07-21
      id: search_data?.id, // hotel's id
      adults: search_data?.adults || 'Not set',
      children: search_data?.children || 'Not set',
      htlName: search_data?.title,
      amount: totalsum,
      // ##### 25-02-18 Komarov
      nrf,
      // ##### 24-04-17 Komarov
      room_name,
      max_adults,
      tariff_type_name,
      // ##### 24-05-01 Komarov
      cityName:
        search_data?.cityName ||
        (localized_city_name !== 'undefined' && localized_city_name) ||
        hotelcontent.data?.ci_title,
      available_now,
      // ##### Komarov 2025-05-26
      hotel_category: hotelcontent?.data?.hotels?.[search_data?.id].star_name,
      // ##### 24-05-01 Komarov
      city_id: search_data?.city_id,
      // ##### 25-05-15 Komarov
      hotelCurrencyId,
    });
    // ##### 24-12-27 Komarov
    const route_query = `?${shouldCypherUrlParams ? encryptString(params_string) : params_string}`;

    // ##### 24-02-29 Komarov: TODO: Убрать промокод из URL
    if (isWhiteLabelSet) {
      const currentUrl = `/ref${company_cipher}/booking_form/${route_query}`;
      // ##### 24-08-01 Komarov
      // writeUrlToRedux(currentUrl);
      history.push(`/${locale}${currentUrl}`, [...booking, newBooking]);
    } else if (promoCode) {
      // ##### 24-08-05 Komarov
      // TODO: Происходит смешивание понятий refpartner и promoCode, - нужно что-то с этим сделать
      const currentUrl = `/booking_form/${route_query}`;
      // ##### 24-08-01 Komarov
      // writeUrlToRedux(currentUrl);
      history.push(`/${locale}${currentUrl}`, [...booking, newBooking]);
    } else {
      const currentUrl = `/booking_form/${route_query}`;
      // ##### 24-08-01 Komarov
      // writeUrlToRedux(currentUrl);
      history.push(`/${locale}${currentUrl}`, [...booking, newBooking]);
    }
  };

  // ##### 23-03-01 Komarov
  return (
    // ##### Komarov 2025-07-22
    <>
      {/* ##### 24-04-16 Komarov */}
      <Media greaterThanOrEqual="Tablet-768-1024">
        <BookButtonHotelButton
          className={
            (available_now && 'AddToBasketButtonAllotment') ||
            'AddToBasketButtonRequest'
          }
          AddToBasket={AddToBasket}
          available_now={available_now}
        />
      </Media>
      <Media lessThan="Tablet-768-1024">
        <BookButtonHotelButton
          className={
            (available_now && 'AddToBasketButtonSmallScreenAllotment') ||
            'AddToBasketButtonSmallScreenRequest'
          }
          AddToBasket={AddToBasket}
          available_now={available_now}
        />
      </Media>
    </>
  );
};

export default BookButtonHotel;
